import React, { useEffect, useState, useCallback } from 'react';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { getProgress, updateProgress } from './firebaseConfig';
import { Box, Button } from '@mui/material';

const UnityWebGL = ({ organization }) => {
  const [loading, setLoading] = useState(false);

  const urls = {
    loaderUrl: process.env.REACT_APP_UNITY_LOADER_URL,
    dataUrl: process.env.REACT_APP_UNITY_DATA_URL,
    frameworkUrl: process.env.REACT_APP_UNITY_FRAMEWORK_URL,
    codeUrl: process.env.REACT_APP_UNITY_CODE_URL
  }

  //  const urls = {
  //    loaderUrl: `${buildName}/Build/${buildName}.loader.js`,
  //    dataUrl: `${buildName}/Build/${buildName}.data`,
  //    frameworkUrl: `${buildName}/Build/${buildName}.framework.js`,
  //    codeUrl:`${buildName}/Build/${buildName}.wasm`
  //  }

  const { unityProvider, isLoaded, loadingProgression, sendMessage, addEventListener, removeEventListener, requestFullscreen } = useUnityContext({
    loaderUrl: urls.loaderUrl,
    dataUrl: urls.dataUrl,
    frameworkUrl: urls.frameworkUrl,
    codeUrl: urls.codeUrl,
  });

  const handleLoadProgress = useCallback(async () => {
    console.log("HANDLE LOAD PROGRESS FOR ORG " + organization);
    let progress = await getProgress(organization);
    sendMessage("FirebaseManager", "LoadUserProgress", progress);
  }, [sendMessage, organization]);

  const handleStoreProgress = useCallback((data) => {
    console.log("The stored data: " + data);
    updateProgress(organization, data);
  }, [organization]);

  useEffect(() => {
    addEventListener("RequestUserProgress", handleLoadProgress);
    return () => {
      removeEventListener("RequestUserProgress", handleLoadProgress);
    };
  }, [addEventListener, removeEventListener, handleLoadProgress]);

  useEffect(() => {
    addEventListener("StoreUserProgress", handleStoreProgress);
    return () => {
      removeEventListener("StoreUserProgress", handleStoreProgress);
    };
  }, [addEventListener, removeEventListener, handleStoreProgress]);

  if (loading) {
    return <p>Loading URLs...</p>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      {!isLoaded && <p>Loading Application... {Math.round(loadingProgression * 100)}%</p>}
      <Unity unityProvider={unityProvider} style={{ width: '50%', height: '50%' }} />
      <Button
        variant="contained"
        color="primary"
        onClick={() => requestFullscreen(true)}
        sx={{ mt: 2 }}
      >
        Enter Full Screen
      </Button>
    </Box>
  );
};

export default UnityWebGL;
